import { styled } from "@mui/material"

export const Section = styled('main')(({ theme }) => (props) => ({
    padding: '24px  96px  ',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px  ',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px  ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px  '
    },
}))
export const RightSection = styled('section')(({ theme }) => (props) => ({
    flex: '1',
    
}))

export const TextSection = styled('div')(({ theme }) => (props) => ({
    minHeight: '100%',
    margin: ' 24px 80px 24px 0 ',
    width: '90%',
    marginBottom: '32px',
    "& > h2 ": {
        color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
        fontSize: theme.typography.HeadingHero.fontSize,
        fontWeight: theme.typography.HeadingHero.fontWeight,
        lineHeight: theme.typography.HeadingHero.lineHeight,
        letterSpacing: theme.typography.HeadingHero.letterSpacing,
        wordSpacing: '1px',
        margin: '0 5px',
        [theme.breakpoints.down('md')]: {
            fontSize: '26px',
            lineHeight: '30px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            lineHeight: '30px',
        }
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        textAlign: 'left',
        margin: ' 24px 16px',
    },
    "& > p ": {
        fontSize: '1.5vw',
        fontWeight: '400',
        lineHeight: '2.3vw',
        letterSpacing: '0em',
        textAlign: 'justify',
        margin: "5px",
        color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
            lineHeight: '22.5px',
            textAlign: 'start',

        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            width: '90%',
            lineHeight: '19.5px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '16px',
            width: '90%',
            lineHeight: '19.5px',
        }

    }
}

))
export const TextTitle = styled('h2')(({ theme }) => (props) => ({
   
}))
export const TextDesc = styled('p')(({ theme }) => (props) => ({
    margin: '0',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '17px',
    width: '90%',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark
}))
export const LeftSection = styled('section')(({ theme }) => (props) => ({
    width: '35%',
    padding: ' 40px 32px',
    background: "#0056D21A",
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
        borderLeft: 'none',
        padding: '12px',
    },
    [theme.breakpoints.down('sm')]: {
        width: '90%',
        padding: '12px',
    },
}))
export const TextHeading = styled('h6')(({ theme }) => (props) => ({
    margin: '0 0  14px 0',
    fontSize: '18px',
    fontWeight: 800,
    lineHeight: '20px',
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))

export const Image = styled('img')(({ theme }) => (props) => ({
    maxWidth: '100%',
    maxHeight: '100%',
}))